var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"leaderboard-stats"},[_c('div',{staticClass:"row"},[_c('cmg-leaderboard-favorite')],1),_c('div',{staticClass:"row"},[_c('cmg-leaderboard-locations'),_c('cmg-leaderboard-badges-earned')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }